import { useEffect } from "react";

// Admin pages: tell search engines not to index or follow them. robots.txt also
// disallows /admin/, and every admin API call requires the admin token.
export default function useNoIndex() {
  useEffect(() => {
    let tag = document.querySelector('meta[name="robots"]');
    const created = !tag;
    const previous = tag ? tag.getAttribute("content") : null;
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "robots");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", "noindex, nofollow");
    return () => {
      if (created) tag.remove();
      else tag.setAttribute("content", previous);
    };
  }, []);
}
